import angular from 'angular';
import { LoadingDotsComponent } from './loading-dots.component';

export const LoadingDotsModule = angular
  .module('app.directives.loading-dots', [])
  .component('updLoadingDots', LoadingDotsComponent);
